export const theme = {
  border: {
    buttonRadius: "3px",
    cardRadius: "6px"
  },
  colors: {
    black: "#000000",
    white: "#FFFFFF",
    lightgray: "#F5F6F0",
    gray: "#C6CDC1",
    darkgray: "#44403F",
    green: "#63A15F",
    yellow: "#FEDE00",
    orange: "#FF6501",
    blue: "#278ED5",
    red: "#e52626"
  },
  font: {
    title: "'Kalbe System', sans-serif",
    body: "'Kalbe Geometric', sans-serif",
    accent: "'Kalbe System', sans-serif"
  },
  shadow: {
    normal: "0px -1px 1px rgba(0, 0, 0, 0.1)",
    bold: "0px 4px 4px rgba(0, 0, 0, 0.25);"
  }
};
